export default __webpack_public_path__ + "static/media/Väldfärdsmiljardärerna_mixare.16e29745.jpeg";